/**
* @constant
* @memberof module:CustomUi
* @type {String}
* @default
*/
export const CUSTOM_UI_EVENT_PREFIX = 'ui';

/**
 * @constant
 * @memberof module:CustomUi
 * @type {String}
 * @default
 */
export const MEISTER_DATA_ID_ATTR = 'data-mstr-id';

/**
 * @constant
 * @memberof module:CustomUi
 * @type {String}
 * @default
 */
export const MEISTER_DATA_EVENTS_ATTR = 'data-mstr-events';

/**
* @constant
* @memberof module:CustomUi
* @type {String}
* @default
 */
export const MEISTER_DATA_STANDARD_ATTR = 'data-mstr-standard';

/**
* @constant
* @memberof module:CustomUi
* @type {String}
* @default
 */
export const MEISTER_DATA_DIRECTIVE_ATTR = 'data-mstr-directive';



// WEBPACK FOOTER //
// ./src/js/lib/constants.js